import { aboutContent } from '@/mocks/home';

export default function SectionAbout() {
  return (
    <section id="about" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-[800px] mx-auto text-center">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
            <i className="ri-information-line text-primary-500 mr-2"></i>
            {aboutContent.title}
          </h2>
          <div className="space-y-4">
            {aboutContent.paragraphs.map((p, idx) => (
              <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}